import React, { Component } from 'react'
import CSSModules from 'react-css-modules'

import FulcrumDivider from 'components/fulcrum/divider/Divider'

import styles from './styles.scss'

const Divider = (props) => {
  return (
    <FulcrumDivider className={styles.divider + " " + props.className} />
  )
}

export default CSSModules(Divider, styles)
